import { setupApps } from "./apps/setup"
import { setupComponents } from "./components/module"
import { setupDoclib } from "./doclib/setup"
import { setupHoldings } from "./holding/setup"
import { setupI18n } from "./i18n/setup"
import { setupInfrastructure } from "./infrastructure/setup"
import { setupMain } from "./main/setup"
import { setupMap } from "./map/setup"
import { NutritionVersionService } from "./nutrition/version/service"
import { setupPartners } from "./partners/setup"
import { setupPlanValidation } from "./plans/validation/service"
import { setupReact } from "./react/setup"
import { setupSession } from "./session/setup"
import { SharedDataServiceImpl } from "./sharedData"
import { setupShell } from "./shell/setup"
import { setUsers } from "./user/setup"

export function setupShared(module: ng.IModule) {
    setupInfrastructure(module)
    setupSession(module)
    setupI18n(module)
    setupApps(module)
    setupMap(module)
    setupShell(module)
    setupMain(module)
    setUsers(module)
    setupHoldings(module)
    setupComponents(module)
    setupReact(module)
    setupDoclib(module)
    setupPartners(module)

    module.service("OmniaSharedData", SharedDataServiceImpl)

    module.service("OmniaNutritionVersion", NutritionVersionService)

    setupPlanValidation(module)
}
